import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import App from './App';
import {store} from './redux/store';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';



const container = document?.getElementById('mmm-sosi2022-root');
const locale = container?.getAttribute('data-lang') ?? 'en_US';
const year = container?.getAttribute('data-year') ?? '2022';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App locale={locale} year={year} />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  container
);
